import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {TreatmentDefinitionDataService} from './impl/service/ngrx/treatmentDefinitionData.service';
import {TreatmentDefinitionRepository} from './impl/service/ngrx/treatmentDefinition.repository';


@NgModule()
export class TreatmentDefinitionModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: TreatmentDefinitionDataService,
                service: TreatmentDefinitionRepository,
    ) {

        entityDataService.registerServices({
            TreatmentDefinition: dataService,
        });

        entityServices.registerEntityCollectionServices({
            TreatmentDefinition: service,
        });
    }
}
